// extracted by mini-css-extract-plugin
export default {"root":"SideBlock_root__GMn5X","title":"SideBlock_title__o4mpY"};